import type { AnalyticsBrowser } from '@segment/analytics-next';
import { AUTH_SESSION_START, LOG_OUT } from '../actions';
import type { Middleware } from 'redux';

const middleware =
	(analytics: AnalyticsBrowser): Middleware =>
	() =>
	(next) => {
		let sessionGeneration = 0;

		return (action) => {
			const result = next(action);

			switch (action.type) {
				case AUTH_SESSION_START: {
					const generation = ++sessionGeneration;
					analytics
						.user()
						.then((user) => {
							// user() can resolve after logout or a newer session.
							if (generation !== sessionGeneration) {
								return undefined;
							}
							user.traits({});
							return analytics.identify(action.uuid);
						})
						.catch(console.error);
					break;
				}
				case LOG_OUT:
					sessionGeneration += 1;
					analytics.reset();
					break;
				default:
					break;
			}

			return result;
		};
	};
export default middleware;
